export const pharmacyType = {
    SET_PHARMACY_ID: 'PHARMACY_SET_ID',
    SET_LOCATION_ID: 'LOCATION_SET_ID',
    GET_PHARMACY_REQUEST: 'PHARMACY_GET_DATA_REQUEST',
    GET_PHARMACY_SUCCESS: 'PHARMACY_GET_DATA_SUCCESS',
    GET_PHARMACY_FAILURE: 'PHARMACY_GET_DATA_FAILURE',
    };

    export default pharmacyType;